module.exports = __webpack_public_path__ + "media/icons/arrow-down-2@3x-6fc54bbc.svg";